import { render, staticRenderFns } from "./EditPaymentVoucher.vue?vue&type=template&id=542a74dd"
import script from "./EditPaymentVoucher.vue?vue&type=script&lang=js"
export * from "./EditPaymentVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports